import { render } from "./BookLayout.vue?vue&type=template&id=fbb23a12&scoped=true"
import script from "./BookLayout.vue?vue&type=script&lang=js"
export * from "./BookLayout.vue?vue&type=script&lang=js"

import "./BookLayout.vue?vue&type=style&index=0&id=fbb23a12&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbb23a12"]])

export default __exports__